module.exports = __webpack_public_path__ + "img/icon_logout.3d281b5c.svg";